import React, { useState } from 'react'
import { 
  Header,
  MainContent, 
  MainWrapper,
  SubHeader,
  SubHeader1,
  SubHeaderView,
  TermsButton,
  WrapperDiv, 
} from './styles';
import isMobile from 'tcp-common/lib/utils/is-mobile'
import Modal from 'tcp-common/lib/components/Modal'
import Close from 'tcp-common/lib/svg/Close'
import { callFireWidgetForAnalytics } from '../utility/Analytics';

const TermsAndConditions = () => {
    const isMobileView = isMobile()
    const [termsPopup, setTermsPopup] = useState(false)
    const toggleTermsPopup = () => {
      callFireWidgetForAnalytics('Read Terms and Conditions','Read Terms and Conditions')
      setTermsPopup(!termsPopup)
    }

    const subHeaderContent = () => <SubHeaderView>
      <SubHeader>
        *5% NeuCoins through NeuPass will be applicable post downloading Tata Neu app and registering for NeuPass.
Above illustration is a representation of average spends behavior and may change basis actual spends done.
        </SubHeader>
        <SubHeader1>
          Tata Neu Infinity HDFC Bank Credit Card
        </SubHeader1>
        <SubHeader>
        5% back as NeuCoins on spends on partner TATA Brands, only applicable on Non-EMI Spends, EMI Spends on these merchants will have 1.5% back as NeuCoins. The partner TATA Brands eligible for the additional points will be communicated from time to time. W.e.f. 01-Aug-24, eligible UPI spends on RuPay variant will have 0.50% back as NeuCoins & additional 1% back as NeuCoins on UPI payments via Tata Neu UPI ID, T&C apply. | NeuCoins will not be accrued on fuel, government, rental, post transation EMI conversion and wallet re-loads. NeuCoins issued on the card will be governed by the Fair Usage Policy updated on the bank's website, www.hdfc.bank.in | 1 NeuCoin = ₹1 redeemable on TATA Neu App | For details and T&C on NeuCoins and additional 5% back as NeuCoins via TATA NeuPass Membership, visit <a href="https://www.tataneu.com/about-neupass" style={{textDecorations:"none", color:"inherit"}}>https://www.tataneu.com/about-neupass</a> | Get 1,499 NeuCoins on Tata Neu App (as reversal of 1st Year Membership Fees), applicable on 1st retail transaction done within 30 days of card issuance and will be credited within 60 days of such transaction,applicable only on priced cards. | W.e.f. 10 Jun 25, Spend Rs.50,000+ in a calendar quarter to avail Domestic Airport Lounge benefit | 5% additional NeuCoins through NeuPass will not be applicable on transactions done on Tanishq, Bill Payment (Tata Pay), Tanishq, Cult.fit, Air India, Tata Play | NeuCoins redemption option is not available on Air India, Tata Play, and Bill Payment on Tata Neu.| For more/ latest product information, Most Important Terms and Conditions & Card Member Agreement, always refer to the product page available on the bank's website, www.hdfc.bank.in
        </SubHeader>
        <SubHeader1>
        Tata Neu Plus HDFC Bank Credit Card
        </SubHeader1>
        <SubHeader>
        2% back as NeuCoins on spends on partner TATA Brands, only applicable on Non-EMI Spends, EMI Spends on these merchants will have 1% back as NeuCoins. The partner TATA Brands eligible for the additional points will be communicated from time to time. W.e.f. 01-Aug-24, eligible UPI spends on RuPay variant will have 0.25% back as NeuCoins & additional 0.75% back as NeuCoins on UPI payments via Tata Neu UPI ID, T&C apply. | NeuCoins will not be accrued on fuel, government, rental, post transation EMI conversion and wallet re-loads. NeuCoins issued on the card will be governed by the Fair Usage Policy updated on the bank's website, www.hdfc.bank.in | 1 NeuCoin = ₹1 redeemable on TATA Neu App | For details and T&C on NeuCoins and additional 5% back as NeuCoins via TATA NeuPass Membership, visit <a href="https://www.tataneu.com/about-neupass" style={{textDecorations:"none", color:"inherit"}}>https://www.tataneu.com/about-neupass</a> | Get 499 NeuCoins on Tata Neu App (as reversal of 1st Year Membership Fees), applicable on 1st retail transaction done within 30 days of card issuance and will be credited within 60 days of such transaction, applicable only on priced cards. | W.e.f. 10 Jun 25, Spend Rs.50,000+ in a calendar quarter to avail Domestic Airport Lounge benefit | 5% additional NeuCoins through NeuPass will not be applicable on transactions done on Tanishq Bill Payment (Tata Pay), Tanishq, Cult.fit, Air India, Tata Play| NeuCoins redemption option is not available on Air India, Tata Play, and Bill Payment on Tata Neu.| For more/ latest product information, Most Important Terms and Conditions & Card Member Agreement, always refer to the product page available on the bank's website, www.hdfc.bank.in
        </SubHeader>
    </SubHeaderView>

    const renderDesktopView = () => <MainWrapper>
        <MainContent flexDirection='column'>
           <Header>
           Tata Neu HDFC Bank Credit Card Terms and Conditions
           </Header>
           {subHeaderContent()}
        </MainContent>
    </MainWrapper>

    const renderMobileView = () => <MainWrapper flexDirection='column'>
        <TermsButton onClick={toggleTermsPopup}>
          Read Tata Neu HDFC Bank Credit Card Terms and Conditions
        </TermsButton>
        <Modal
          show={termsPopup}
          onCloseCallBack={toggleTermsPopup}
          modalDialogProps={{inputProps: {
            style: {
              top: '186px',
            }}
          }}
          iconButtonProps={{
            style: {
              display: 'none'
            }
          }}
        >
          <WrapperDiv>
            <MainContent flexDirection='column'>
              <Header>Tata Neu HDFC Bank Credit Card Terms and Conditions</Header>
              {subHeaderContent()}
              <Close
                onClick={toggleTermsPopup}
                style={{
                  position: 'absolute',
                  top: '16px',
                  right: '22px',
                  cursor: 'pointer'
                }}
              />
            </MainContent>
          </WrapperDiv>
        </Modal>
    </MainWrapper>

    const renderView = () => isMobileView ? renderMobileView() : renderDesktopView()
    
    return renderView();
}

export default TermsAndConditions
